import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import logoImage from "../assets/images/logo.png";
import gravatarUrl from "gravatar-url";
import { userLoggedOut } from "../features/auth/authSlice";
import { useEffect, useState } from "react";
import { setSearchText } from "../features/projects/projectSlice";

export default function Navigation() {
    const dispatch = useDispatch();
    const location = useLocation();
    const {user} = useSelector(state => state.auth) || {};
    const [search, setSearch] = useState("");

    const logout = () => {
        dispatch(userLoggedOut());
        localStorage.clear();
    };

    useEffect(() => {
        dispatch(setSearchText(search));
    }, [search]);

    return (
        <div
        className="flex items-center flex-shrink-0 w-full h-16 px-10 bg-white bg-opacity-75"
    >
        <img src={logoImage} className="h-10 w-10" alt = "logo" />
        {location.pathname === "/projects" &&
            <input
                className="flex items-center h-10 px-4 ml-10 text-sm bg-gray-200 rounded-full focus:outline-none focus:ring"
                type="search"
                placeholder="Search Title"
                value = {search}
                onChange = {e => setSearch(e.target.value)}
            />
        }
        <div className="ml-10">
            <Link to = "/projects"
                className={`mx-2 text-sm font-semibold ${location.pathname === "/projects" ? "text-indigo" : "text-gray"}-700`}
            >
                Projects
            </Link>
            <Link to = "/teams"
                className={`mx-2 text-sm font-semibold ${location.pathname === "/teams" ? "text-indigo" : "text-gray"}-700`}
                href="teams.html"
            >
                Team
            </Link>
        </div>
        <Link to = "/"
            className="flex items-center justify-center w-8 h-8 ml-auto overflow-hidden rounded-full cursor-pointer"
        >
            <img
                src={gravatarUrl(user?.email, {
                    size: 80
                })}
                alt="user"
            />
        </Link>
        <ul>
            <li className="text-black ml-2">
                <span className="cursor-pointer" onClick={logout}>
                    Logout
                </span>
            </li>
        </ul>
    </div>
    );
}
